import { html } from 'lit';
// https://icons.getbootstrap.com/
export const phoneIcon = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="17"
  height="17"
  viewBox="0 0 17 17"
  fill="none"
>
  <mask id="mask0_616_1380" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="17" height="17">
    <rect width="17" height="17" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_616_1380)">
    <path
      d="M14.1313 14.875C12.6083 14.875 11.1238 14.5356 9.6776 13.8568C8.23142 13.178 6.95052 12.2807 5.8349 11.1651C4.71927 10.0495 3.82205 8.76858 3.14323 7.3224C2.46441 5.87622 2.125 4.39167 2.125 2.86875C2.125 2.65625 2.19583 2.47917 2.3375 2.3375C2.47917 2.19583 2.65625 2.125 2.86875 2.125H5.7375C5.90278 2.125 6.05035 2.17813 6.18021 2.28437C6.31007 2.39062 6.38681 2.52639 6.41042 2.69167L6.87083 5.17083C6.89444 5.33611 6.89149 5.48663 6.86198 5.6224C6.83247 5.75816 6.76458 5.87917 6.65833 5.98542L4.94062 7.72083C5.43646 8.57083 6.0592 9.36771 6.80885 10.1115C7.55851 10.8552 8.38194 11.4986 9.27917 12.0417L10.9437 10.3771C11.05 10.2708 11.1887 10.1911 11.3599 10.138C11.5311 10.0849 11.6993 10.0701 11.8646 10.0938L14.3083 10.5896C14.4736 10.625 14.6094 10.7047 14.7156 10.8286C14.8219 10.9526 14.875 11.0972 14.875 11.2625V14.1313C14.875 14.3438 14.8042 14.5208 14.6625 14.6625C14.5208 14.8042 14.3438 14.875 14.1313 14.875ZM4.26771 6.375L5.43646 5.20625L5.13542 3.54167H3.55938C3.6184 4.02569 3.70104 4.50382 3.80729 4.97604C3.91354 5.44826 4.06701 5.91458 4.26771 6.375ZM10.6073 12.7146C11.0677 12.9153 11.537 13.0747 12.0151 13.1927C12.4932 13.3108 12.9743 13.3875 13.4583 13.4229V11.8646L11.7937 11.5281L10.6073 12.7146Z"
      fill="white"
    />
  </g>
</svg>`;
// https://icons.getbootstrap.com/icons/plus/
export const plusIcon = html ` <svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  fill="currentColor"
  class="bi bi-plus"
  viewBox="0 0 16 16"
>
  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
</svg>`;
//https://icons.getbootstrap.com/icons/x/
export const xIcon = html ` <svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  fill="currentColor"
  class="bi bi-x"
  viewBox="0 0 16 16"
>
  <path
    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
  />
</svg>`;
// https://icons.getbootstrap.com/icons/pencil-square/
export const pencilSquareIcon = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  fill="currentColor"
  class="bi bi-pencil-square"
  viewBox="0 0 16 16"
>
  <path
    d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"
  />
  <path
    fill-rule="evenodd"
    d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
  />
</svg>`;
// https://icons.getbootstrap.com/icons/arrow-left/
export const leftArrowIcon = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  fill="currentColor"
  class="bi bi-arrow-left"
  viewBox="0 0 16 16"
>
  <path
    fill-rule="evenodd"
    d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
  />
</svg>`;
// https://icons.getbootstrap.com/icons/trash3/
export const deleteIcon = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  fill="currentColor"
  class="bi bi-trash3"
  viewBox="0 0 16 16"
>
  <path
    d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z"
  />
</svg>`;
// https://icons.getbootstrap.com/icons/person/
export const personicon = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  fill="currentColor"
  class="bi bi-person"
  viewBox="0 0 16 16"
>
  <path
    d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4Zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10Z"
  />
</svg>`;
// https://icons.getbootstrap.com/icons/person-add/
export const loginIcon = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  fill="currentColor"
  class="bi bi-person-add"
  viewBox="0 0 16 16"
>
  <path
    d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0Zm-2-6a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
  />
  <path
    d="M8.256 14a4.474 4.474 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10c.26 0 .507.009.74.025.226-.341.496-.65.804-.918C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4s1 1 1 1h5.256Z"
  />
</svg>`;
// Email Icon
export const emailIcon = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
>
  <mask id="mask0_529_532" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
    <rect width="24" height="24" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_529_532)">
    <path
      d="M4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4ZM12 13L4 8V18H20V8L12 13ZM12 11L20 6H4L12 11ZM4 8V6V18V8Z"
      fill="#373737"
    />
  </g>
</svg>`;
// Call Icon
export const callIcon = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
>
  <mask id="mask0_529_454" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
    <rect width="24" height="24" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_529_454)">
    <path
      d="M19.95 21C17.8 21 15.7042 20.5208 13.6625 19.5625C11.6208 18.6042 9.8125 17.3375 8.2375 15.7625C6.6625 14.1875 5.39583 12.3792 4.4375 10.3375C3.47917 8.29583 3 6.2 3 4.05C3 3.75 3.1 3.5 3.3 3.3C3.5 3.1 3.75 3 4.05 3H8.1C8.33333 3 8.54167 3.075 8.725 3.225C8.90833 3.375 9.01667 3.56667 9.05 3.8L9.7 7.3C9.73333 7.53333 9.72917 7.74583 9.6875 7.9375C9.64583 8.12917 9.55 8.3 9.4 8.45L6.975 10.9C7.675 12.1 8.55417 13.225 9.6125 14.275C10.6708 15.325 11.8333 16.2333 13.1 17L15.45 14.65C15.6 14.5 15.7958 14.3875 16.0375 14.3125C16.2792 14.2375 16.5167 14.2167 16.75 14.25L20.2 14.95C20.4333 15 20.625 15.1125 20.775 15.2875C20.925 15.4625 21 15.6667 21 15.9V19.95C21 20.25 20.9 20.5 20.7 20.7C20.5 20.9 20.25 21 19.95 21ZM6.025 9L7.675 7.35L7.25 5H5.025C5.10833 5.68333 5.225 6.35833 5.375 7.025C5.525 7.69167 5.74167 8.35 6.025 9ZM14.975 17.95C15.625 18.2333 16.2875 18.4583 16.9625 18.625C17.6375 18.7917 18.3167 18.9 19 18.95V16.75L16.65 16.275L14.975 17.95Z"
      fill="#373737"
    />
  </g>
</svg>`;
export const hideIcon = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="17"
  height="17"
  viewBox="0 0 17 17"
  fill="none"
>
  <mask id="mask0_616_1251" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="17" height="17">
    <rect x="0.5" y="0.5" width="16" height="16" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_616_1251)">
    <path
      d="M11.2333 9.3667L10.2666 8.40003C10.3666 7.87781 10.2166 7.38892 9.81663 6.93337C9.41663 6.47781 8.89996 6.30003 8.26663 6.40003L7.29996 5.43337C7.48885 5.34448 7.68051 5.27781 7.87496 5.23337C8.0694 5.18892 8.27774 5.1667 8.49996 5.1667C9.33329 5.1667 10.0416 5.45837 10.625 6.0417C11.2083 6.62503 11.5 7.33337 11.5 8.1667C11.5 8.38892 11.4777 8.59726 11.4333 8.7917C11.3888 8.98614 11.3222 9.17781 11.2333 9.3667ZM13.3666 11.4667L12.4 10.5334C12.8222 10.2111 13.1972 9.85837 13.525 9.47503C13.8527 9.0917 14.1333 8.65559 14.3666 8.1667C13.8111 7.04448 13.0138 6.15281 11.975 5.4917C10.9361 4.83059 9.77774 4.50003 8.49996 4.50003C8.17774 4.50003 7.86107 4.52225 7.54996 4.5667C7.23885 4.61114 6.93329 4.67781 6.63329 4.7667L5.59996 3.73337C6.05552 3.54448 6.52218 3.40281 6.99996 3.30837C7.47774 3.21392 7.97774 3.1667 8.49996 3.1667C10.1777 3.1667 11.6722 3.63059 12.9833 4.55837C14.2944 5.48614 15.2444 6.68892 15.8333 8.1667C15.5777 8.82226 15.2416 9.43059 14.825 9.9917C14.4083 10.5528 13.9222 11.0445 13.3666 11.4667ZM13.7 15.5667L10.9 12.8C10.5111 12.9223 10.1194 13.0139 9.72496 13.075C9.33052 13.1361 8.92218 13.1667 8.49996 13.1667C6.82218 13.1667 5.32774 12.7028 4.01663 11.775C2.70552 10.8473 1.75551 9.64448 1.16663 8.1667C1.39996 7.57781 1.6944 7.03059 2.04996 6.52503C2.40551 6.01948 2.81107 5.5667 3.26663 5.1667L1.43329 3.30003L2.36663 2.3667L14.6333 14.6334L13.7 15.5667ZM4.19996 6.10003C3.87774 6.38892 3.58329 6.70559 3.31663 7.05003C3.04996 7.39448 2.82218 7.7667 2.63329 8.1667C3.18885 9.28892 3.98607 10.1806 5.02496 10.8417C6.06385 11.5028 7.22218 11.8334 8.49996 11.8334C8.72218 11.8334 8.93885 11.8195 9.14996 11.7917C9.36107 11.7639 9.57774 11.7334 9.79996 11.7L9.19996 11.0667C9.07774 11.1 8.96107 11.125 8.84996 11.1417C8.73885 11.1584 8.62218 11.1667 8.49996 11.1667C7.66663 11.1667 6.95829 10.875 6.37496 10.2917C5.79163 9.70837 5.49996 9.00003 5.49996 8.1667C5.49996 8.04448 5.50829 7.92781 5.52496 7.8167C5.54163 7.70559 5.56663 7.58892 5.59996 7.4667L4.19996 6.10003Z"
      fill="#1C1B1F"
    />
  </g>
</svg>`;
export const showIcon = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="17"
  viewBox="0 0 16 17"
  fill="none"
>
  <mask id="mask0_593_1461" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="17">
    <rect y="0.5" width="16" height="16" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_593_1461)">
    <path
      d="M7.99996 11.1666C8.83329 11.1666 9.54163 10.875 10.125 10.2916C10.7083 9.70829 11 8.99996 11 8.16663C11 7.33329 10.7083 6.62496 10.125 6.04163C9.54163 5.45829 8.83329 5.16663 7.99996 5.16663C7.16663 5.16663 6.45829 5.45829 5.87496 6.04163C5.29163 6.62496 4.99996 7.33329 4.99996 8.16663C4.99996 8.99996 5.29163 9.70829 5.87496 10.2916C6.45829 10.875 7.16663 11.1666 7.99996 11.1666ZM7.99996 9.96663C7.49996 9.96663 7.07496 9.79163 6.72496 9.44163C6.37496 9.09163 6.19996 8.66663 6.19996 8.16663C6.19996 7.66663 6.37496 7.24163 6.72496 6.89163C7.07496 6.54163 7.49996 6.36663 7.99996 6.36663C8.49996 6.36663 8.92496 6.54163 9.27496 6.89163C9.62496 7.24163 9.79996 7.66663 9.79996 8.16663C9.79996 8.66663 9.62496 9.09163 9.27496 9.44163C8.92496 9.79163 8.49996 9.96663 7.99996 9.96663ZM7.99996 13.1666C6.37774 13.1666 4.89996 12.7138 3.56663 11.8083C2.23329 10.9027 1.26663 9.68885 0.666626 8.16663C1.26663 6.6444 2.23329 5.43052 3.56663 4.52496C4.89996 3.6194 6.37774 3.16663 7.99996 3.16663C9.62218 3.16663 11.1 3.6194 12.4333 4.52496C13.7666 5.43052 14.7333 6.6444 15.3333 8.16663C14.7333 9.68885 13.7666 10.9027 12.4333 11.8083C11.1 12.7138 9.62218 13.1666 7.99996 13.1666ZM7.99996 11.8333C9.25552 11.8333 10.4083 11.5027 11.4583 10.8416C12.5083 10.1805 13.3111 9.28885 13.8666 8.16663C13.3111 7.0444 12.5083 6.15274 11.4583 5.49163C10.4083 4.83051 9.25552 4.49996 7.99996 4.49996C6.7444 4.49996 5.59163 4.83051 4.54163 5.49163C3.49163 6.15274 2.68885 7.0444 2.13329 8.16663C2.68885 9.28885 3.49163 10.1805 4.54163 10.8416C5.59163 11.5027 6.7444 11.8333 7.99996 11.8333Z"
      fill="#1C1B1F"
    />
  </g>
</svg>`;
export const locationIcon = html `<svg
  width="17"
  height="21"
  viewBox="0 0 17 21"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M8.83795 10.6902C9.38795 10.6902 9.85879 10.4943 10.2505 10.1027C10.6421 9.71099 10.838 9.24016 10.838 8.69016C10.838 8.14016 10.6421 7.66932 10.2505 7.27766C9.85879 6.88599 9.38795 6.69016 8.83795 6.69016C8.28795 6.69016 7.81712 6.88599 7.42545 7.27766C7.03379 7.66932 6.83795 8.14016 6.83795 8.69016C6.83795 9.24016 7.03379 9.71099 7.42545 10.1027C7.81712 10.4943 8.28795 10.6902 8.83795 10.6902ZM8.83795 18.0402C10.8713 16.1735 12.3796 14.4777 13.363 12.9527C14.3463 11.4277 14.838 10.0735 14.838 8.89015C14.838 7.07349 14.2588 5.58599 13.1005 4.42765C11.9421 3.26932 10.5213 2.69016 8.83795 2.69016C7.15462 2.69016 5.73378 3.26932 4.57545 4.42765C3.41712 5.58599 2.83795 7.07349 2.83795 8.89015C2.83795 10.0735 3.32962 11.4277 4.31295 12.9527C5.29629 14.4777 6.80462 16.1735 8.83795 18.0402ZM8.83795 20.6902C6.15462 18.4068 4.15045 16.286 2.82545 14.3277C1.50045 12.3693 0.837952 10.5568 0.837952 8.89015C0.837952 6.39015 1.64212 4.39849 3.25045 2.91516C4.85879 1.43182 6.72129 0.690155 8.83795 0.690155C10.9546 0.690155 12.8171 1.43182 14.4255 2.91516C16.0338 4.39849 16.838 6.39015 16.838 8.89015C16.838 10.5568 16.1755 12.3693 14.8505 14.3277C13.5255 16.286 11.5213 18.4068 8.83795 20.6902Z"
    fill="#7E7E7E"
  />
</svg> `;
export const twirlDownIcon = html `<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <mask id="mask0_87_152" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
    <rect width="24" height="24" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_87_152)">
    <path d="M12.6 12L8 7.4L9.4 6L15.4 12L9.4 18L8 16.6L12.6 12Z" fill="#787773" />
  </g>
</svg> `;
export const twirlUpIcon = html `<svg
  width="25"
  height="25"
  viewBox="0 0 25 25"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <mask id="mask0_87_140" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="25">
    <rect x="0.230225" y="0.201416" width="24" height="24" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_87_140)">
    <path
      d="M12.2302 15.6014L6.23022 9.60142L7.63022 8.20142L12.2302 12.8014L16.8302 8.20142L18.2302 9.60142L12.2302 15.6014Z"
      fill="#787773"
    />
  </g>
</svg> `;
export const buttonArrowIcon = html `<svg
  width="25"
  height="25"
  viewBox="0 0 25 25"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <mask id="mask0_2_7" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="25">
    <rect x="0.836609" y="0.0274048" width="24" height="24" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_2_7)">
    <path
      d="M7.23661 18.0274L5.83661 16.6274L15.4366 7.0274H6.83661V5.0274H18.8366V17.0274H16.8366V8.4274L7.23661 18.0274Z"
      fill="white"
    />
  </g>
</svg> `;
